import styles from "./styles.module.scss"
import Checkmark from "~icons/eva/checkmark-fill"
import { StripeSubscriptionStatus } from "../../../../../../../firebase/functions/src/libs/cruisen-contract"

export const SubscriptionActivated = ({
  onSuccess,
  subscriptionHasPaymentMethod,
  subscriptionStatus,
  trialPeriodDays,
}: {
  onSuccess: () => void
  subscriptionHasPaymentMethod?: boolean
  subscriptionStatus?: StripeSubscriptionStatus
  trialPeriodDays: number
}) => {
  return (
    <div>
      <div className={styles.container}>
        <div className={styles.iconWrapper}>
          <Checkmark />
        </div>
        <p className={styles.title}>Thank you!</p>
        <p className={styles.description}>
          {subscriptionStatus === "trialing" && !subscriptionHasPaymentMethod
            ? `Your ${trialPeriodDays}-day trial has been activated.`
            : "Thanks so much for choosing Cruisen to help to grow your business."}
        </p>
      </div>
      <button className={styles.continueButton} onClick={() => onSuccess()}>
        {subscriptionStatus === "trialing" && !subscriptionHasPaymentMethod
          ? "Continue"
          : "Continue to Cruisen"}
      </button>
    </div>
  )
}
